// Currencies action types
export const SET_CURRENCIES_DATA = "SET_CURRENCIES_DATA";
export const ADD_CURRENCY = "ADD_CURRENCY";
export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
export const DELETE_CURRENCY = "DELETE_CURRENCY";
